import PageAnswers from './pageAnswers';
export default PageAnswers;
